module.exports = __webpack_public_path__ + "img/connect-claude.689ca8be.svg";